import html2canvas from "html2canvas";

// Returns false on failure instead of throwing, so callers can show a toast
// without needing their own try/catch.
export const exportNodeAsPng = async (node, filename = "export") => {
  if (!node) return false;
  try {
    const canvas = await html2canvas(node, { backgroundColor: "#ffffff", scale: 2 });
    const dataUrl = canvas.toDataURL("image/png");
    const link = document.createElement("a");
    link.href = dataUrl;
    link.download = `${filename}.png`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    return true;
  } catch (error) {
    console.error("Error exporting PNG:", error);
    return false;
  }
};
